module.exports = __webpack_public_path__ + "static/img/image001.5cfe4a37.png";